package com.narbase.letsgo.web.views.support

import com.narbase.kunafa.core.components.TextInput
import com.narbase.kunafa.core.components.TextView
import com.narbase.kunafa.core.components.horizontalLayout
import com.narbase.kunafa.core.components.layout.LinearLayout
import com.narbase.kunafa.core.components.verticalLayout
import com.narbase.kunafa.core.dimensions.vw
import com.narbase.letsgo.dto.KmmLong
import com.narbase.letsgo.dto.core.MultiLingualTextDto
import com.narbase.letsgo.web.dto.support.SupportIssueDto
import com.narbase.letsgo.web.theme.main.MainTheme
import com.narbase.letsgo.web.theme.theme
import com.narbase.letsgo.web.translations.localized
import com.narbase.letsgo.web.utils.horizontalFiller
import com.narbase.letsgo.web.utils.verticalFiller
import com.narbase.letsgo.web.utils.views.*
import com.narbase.letsgo.web.utils.views.customViews.CustomCheckBox
import com.narbase.letsgo.web.utils.views.customViews.customCheckBox
import com.narbase.letsgo.web.views.templates.text

class UpsertSupportIssueDialog(
    private val categoryId: KmmLong,
    private var supportIssue: SupportIssueDto?,
    val onUpdated: () -> Unit
) {
    private val viewModel = SupportIssuesManagementViewModel(categoryId)
    private val popup by lazy { popUpDialog() }
    private var isActiveCheckBox: CustomCheckBox? = null


    private var issueTitleEnInput: TextInput? = null
    private var issueTitleArInput: TextInput? = null
    private var issueTitleFrInput: TextInput? = null

    private var issueBodyEnInput: TextArea? = null
    private var issueBodyArInput: TextArea? = null
    private var issueBodyFrInput: TextArea? = null

    var errorTextView: TextView? = null

    fun show() {
        theme.showDialog(popup, customStyle = MainTheme.ThemeDialogStyle(minWidth = 60.vw)) {
            it.bottomBar = {
                horizontalLayout {
                    matchParentWidth()
                    horizontalFiller()
                    theme.unimportantButton(this) {
                        text = "Dismiss".localized()
                        onClick = {
                            popup.dismissDialog()
                        }
                    }
                    horizontalFiller(20)
                    horizontalLayout {
                        theme.mainButton(this) {
                            text = "Save".localized()
                            onClick = {
                                save()
                            }
                        }.withLoadingAndError(viewModel.upsertUiState, onLoaded = {
                            popup.dismissDialog()
                            onUpdated.invoke()
                        }, onRetryClicked = {
                            save()
                        })
                    }
                }
            }

            mainForm()
        }
    }

    fun LinearLayout.mainForm() = verticalLayout {
        matchParentDimensions()

        issueTitleEnInput = theme.labeledTextInput(this, "Title - en".localized()) {
            placeholder = "Title - en".localized()
        }
        issueTitleEnInput?.text = supportIssue?.title?.en ?: ""
        verticalFiller(10)
        issueTitleArInput = theme.labeledTextInput(this, "Title - ar".localized()) {
            placeholder = "Title - ar".localized()
        }
        issueTitleArInput?.text = supportIssue?.title?.ar ?: ""
        verticalFiller(10)
        issueTitleFrInput = theme.labeledTextInput(this, "Title - fr".localized()) {
            placeholder = "Title - fr".localized()
        }
        issueTitleFrInput?.text = supportIssue?.title?.fr ?: ""
        verticalFiller(10)

        issueBodyEnInput = theme.labeledTextArea(this, "Body - en".localized()) {
            style {
                matchParentWidth()
            }
            placeholder = "Support Body/ Description - en".localized()
        }
        issueBodyEnInput?.text = supportIssue?.body?.en ?: ""
        verticalFiller(10)
        issueBodyArInput = theme.labeledTextArea(this, "Body - ar".localized()) {
            style {
                matchParentWidth()
            }
            placeholder = "Support Body/ Description - ar".localized()
        }
        issueBodyArInput?.text = supportIssue?.body?.ar ?: ""
        verticalFiller(10)
        issueBodyFrInput = theme.labeledTextArea(this, "Body - fr".localized()) {
            style {
                matchParentWidth()
            }
            placeholder = "Support Body/ Description - fr".localized()
        }
        issueBodyFrInput?.text = supportIssue?.body?.fr ?: ""
        verticalFiller(10)

        isActiveCheckBox = customCheckBox(
            "is issue active".localized(), isSelected = supportIssue?.isActive ?: true
        )

        errorTextView = theme.errorText(this) {
            isVisible = false
        }
    }

    fun save() {
        val titleEn = issueTitleEnInput?.text?.trim()
        val titleAr = issueTitleArInput?.text?.trim()
        val titleFr = issueTitleFrInput?.text?.trim()
        val bodyEn = issueBodyEnInput?.text?.trim()
        val bodyAr = issueBodyArInput?.text?.trim()
        val bodyFr = issueBodyFrInput?.text?.trim()
        val isActive = isActiveCheckBox?.isSelected ?: true

        if (titleEn.isNullOrBlank() || titleAr.isNullOrBlank() || titleFr.isNullOrBlank()) {
            errorTextView?.text = "Title can't be null"
            errorTextView?.isVisible = true
            return
        }
        if (bodyEn.isNullOrBlank() || bodyAr.isNullOrBlank() || bodyFr.isNullOrBlank()) {
            errorTextView?.text = "Title can't be null"
            errorTextView?.isVisible = true
            return
        }

        viewModel.upsertSupportIssue(
            SupportIssueDto(
                id = supportIssue?.id,
                categoryId = categoryId,
                title = MultiLingualTextDto(titleEn, titleAr, titleFr),
                body = MultiLingualTextDto(bodyEn, bodyAr, bodyFr),
                isActive = isActive,
                createdOn = supportIssue?.createdOn,
            )
        )
    }
}